import { connect } from '~/store';
import { SelectedElectorates } from '~/helpers/types/Electorate';

/** Store helper: provides the user's currently selected electorates. */
export default (component: any): (props: any) => any => (
  connect(({ electorates }: { electorates: SelectedElectorates }) => ({ electorates }))(component)
);
